import type { InjectionKey, Ref } from 'vue';
import type { NavBarNode, NavBarSide, RegisterFn } from './types';

/** Provided by NavBar (per side) and by every NavBarItem (to its children). */
export const registerNavBarItemKey: InjectionKey<RegisterFn> = Symbol('register-navbar-item');

/** Provided by NavBar; consumed by leaf items to know which root branch they belong to. */
export const navBarSideKey: InjectionKey<NavBarSide> = Symbol('navbar-side');

/** Theme provided by NavBar root. */
export const navBarThemeKey: InjectionKey<'light' | 'dark'> = Symbol('navbar-theme');

/** The single open chain (root → ... → deepest). Provided by NavBar. */
export const navBarOpenPathKey: InjectionKey<Ref<NavBarNode[]>> = Symbol('navbar-open-path');

/** Currently focused node (may be `null` if focus is outside the menubar). */
export const navBarFocusedKey: InjectionKey<Ref<NavBarNode | null>> = Symbol('navbar-focused');
